import { FileUploader } from "react-drag-drop-files";
import styled from "styled-components";

interface DragAndDropProps{
    handleChange:(file:File[]) => void,
    accept:string
}

const DragAndDrop = ({accept, handleChange}:DragAndDropProps) => {
    return (
        <Container>
            <FileUploader 
                multiple={true} 
                classes="file-uploader" 
                handleChange={handleChange} 
                name={accept} 
                types={accept === "image" ? ["jpg", "png", "gif"] : ["mp4", "wav", "mov", "avi", "mp3"]} 
                label="파일을 끌어다 놓거나 클릭하세요"
            />
        </Container>
    );
}

const Container = styled.div`
    width: 100%;
    .file-uploader{
        max-width: 100% !important;
        width: 100% !important;
        min-height: 72px;
        border: 1px dashed #E2E8F0 !important;
        border-radius: 0 !important;
        background: #F8FAFC !important;
        box-sizing: border-box;
    }
    .file-uploader:hover {
        border-color: #DF0000 !important;
        background: #FEF2F2 !important;
    }
`

export default DragAndDrop;
